export const ru = {
    fatalError: 'Во время копирования произошла ошибка. Попробуйте позже',
    noticeMessageError: {
        one: 'Не удалось скопировать {count} группу',
        some: 'Не удалось скопировать {count} группы',
        many: 'Не удалось скопировать {count} групп',
        none: 'Не удалось скопировать {count} групп'
    }
};
